export default __webpack_public_path__ + "static/media/top_left.4d29a076.jpg";